import { render } from "./BottomElement.vue?vue&type=template&id=7070d9a7"
import script from "./BottomElement.vue?vue&type=script&lang=js"
export * from "./BottomElement.vue?vue&type=script&lang=js"

import "./BottomElement.vue?vue&type=style&index=0&id=7070d9a7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__